/*
 *   Copyright (c) 2023 
 *   All rights reserved.
 */
import React from "react";
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal";

const VmoModal = (props) => {
  return <Modal {...props}>{props.children}</Modal>;
};
export default VmoModal;
